import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=48d82082&scoped=true"
import script from "./addEvent.vue?vue&type=script&lang=js"
export * from "./addEvent.vue?vue&type=script&lang=js"
import style0 from "./addEvent.vue?vue&type=style&index=0&id=48d82082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d82082",
  null
  
)

export default component.exports